import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { Query } from "react-apollo";
import classNames from "classnames";
import PropTypes, { instanceOf } from "prop-types";

import SubscribeStreamCap from "stream/components/SubscribeStreamCap";
import EventStreamCap from "stream/components/EventStreamCap";
import ErrorBoundary from "components/Library/ErrorBoundary";
import STREAM_CAP_QUERY from "./StreamCap.graphql";
import { COOKIES } from "config/constants";

import styles from "./StreamCap.css";

class StreamCap extends Component {
  render() {
    const shouldRenderNewsletterSignup = !this.props.cookies.get(
      COOKIES.BLOCK_STREAM_CAP_PROMO
    );

    return (
      <ErrorBoundary>
        <Query query={STREAM_CAP_QUERY}>
          {({ loading, data }) => {
            const { newsletterSignup, event } = data;

            if (loading) {
              return null;
            }

            return (
              <div
                className={classNames(styles.promoContainer, {
                  [styles.padStreamTitle]: this.props.addPaddingForStreamTitle,
                })}
              >
                {event && <EventStreamCap event={event} />}
                {newsletterSignup && shouldRenderNewsletterSignup && (
                  <SubscribeStreamCap promo={newsletterSignup} />
                )}
              </div>
            );
          }}
        </Query>
      </ErrorBoundary>
    );
  }
}

StreamCap.propTypes = {
  addPaddingForStreamTitle: PropTypes.bool,
  cookies: instanceOf(Cookies).isRequired,
};

export default withCookies(StreamCap);
